(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    root.querySelectorAll('[data-skp-devices]').forEach(function(g){
      if(g.dataset.on) return; g.dataset.on = '1';
      var canvas = document.getElementById(g.getAttribute('data-target'));
      g.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          g.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          b.setAttribute('aria-pressed','true');
          if(canvas) canvas.setAttribute('data-device', b.getAttribute('data-device'));
        });
      });
    });
    root.querySelectorAll('.skd-ba').forEach(function(ba){
      if(ba.dataset.on) return; ba.dataset.on = '1';
      var r = ba.querySelector('input'), touched = false;
      function set(v){ ba.style.setProperty('--pos', v + '%'); r.value = v; }
      r.addEventListener('input', function(){ touched = true; set(r.value); });
      ba.addEventListener('pointerdown', function(){ touched = true; });
      if(reduce) return;
      var t0 = null;
      function loop(ts){
        if(touched) return;
        if(!t0) t0 = ts;
        set((50 + 32 * Math.sin((ts - t0) / 1300)).toFixed(1));
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);
    });
    root.querySelectorAll('[data-skd-sticky]').forEach(function(sc){
      if(sc.dataset.on) return; sc.dataset.on = '1';
      var btn = sc.querySelector('[data-skd-buy]'), bar = sc.querySelector('.skd-sticky');
      var hint = sc.parentNode.querySelector('.skd-hint');
      function check(){
        var s = sc.getBoundingClientRect(), b = btn.getBoundingClientRect();
        bar.classList.toggle('is-on', b.bottom < s.top + 10);
      }
      sc.addEventListener('scroll', check, { passive: true });
      check();
      var stop = false;
      ['wheel','touchstart','pointerdown','keydown'].forEach(function(ev){
        sc.addEventListener(ev, function(){ stop = true; if(hint) hint.style.display = 'none'; }, { passive: true });
      });
      if(reduce) return;
      var down = true;
      function tick(){
        if(stop) return;
        sc.scrollTo({ top: down ? sc.scrollHeight : 0, behavior: 'smooth' });
        down = !down;
        setTimeout(tick, 3400);
      }
      setTimeout(tick, 1400);
    });
    root.querySelectorAll('[data-skd-delivery]').forEach(function(d){
      if(d.dataset.on) return; d.dataset.on = '1';
      var cut = parseInt(d.getAttribute('data-cutoff') || '14', 10);
      function isWork(x){ var w = x.getDay(); return w !== 0 && w !== 6; }
      function addWork(x, n){ var y = new Date(x); while(n > 0){ y.setDate(y.getDate() + 1); if(isWork(y)) n--; } return y; }
      function fmt(x){ return x.toLocaleDateString('sv-SE', { weekday: 'short', day: 'numeric', month: 'short' }); }
      function render(){
        var now = new Date(), today = isWork(now) && now.getHours() < cut;
        var ship = today ? now : addWork(now, 1), msg = d.querySelector('[data-cut]');
        if(today){
          var end = new Date(now); end.setHours(cut, 0, 0, 0);
          var m = Math.max(0, Math.round((end - now) / 60000));
          msg.textContent = 'Beställ inom ' + Math.floor(m / 60) + ' h ' + (m % 60) + ' min så skickas den idag';
        } else {
          msg.textContent = 'Beställ nu så skickas den ' + fmt(ship);
        }
        d.querySelector('[data-d0]').textContent = fmt(now);
        d.querySelector('[data-d1]').textContent = fmt(ship);
        d.querySelector('[data-d2]').textContent = fmt(addWork(ship, 1)) + ' – ' + fmt(addWork(ship, 3));
      }
      render(); setInterval(render, 30000);
    });
  }
  function boot(){ init(document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();